import { all, fork, takeEvery } from 'redux-saga/effects';
import pagination from '@/helpers/pagination';
import InvoiceService from '@/services/InvoiceService';
import { types } from './reducer';

function* watchFetchInvoices() {
    yield takeEvery(
        types.REQUEST_FETCH_INVOICES,
        pagination('invoices').saga(InvoiceService),
    );
}

function* paginationSaga() {
    yield all([
        fork(watchFetchInvoices),
    ]);
}

export default paginationSaga;
